// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ouTeg","newExpiryDate":"styles_newExpiryDate__1rsuy","footer":"styles_footer__aPOGC"};